/**************************************************************
 @author liangDengHui
 @date: 2018-5-3
 @description vue过滤器常用方法
 ******************************************************************/

/**************************************************************
 字符串过滤器
 ******************************************************************/
const
	/**
	 * 描述：金额格式化显示，如：6123432.24 -> 6,123,432.24
	 *
	 * @param money: 金额
	 * @param num: 保留的小数位
	 */
	moneyFormat = (money, num) => {
		// 去掉字符串中除数字、点号、负号外的其他字符
		money = cusParseFloat((money + "").replace(/[^\d.-]/g, ""));
		if (num || num === 0) {
			money = money.toFixed(num);
		} else {
			money = money.toFixed(2);
		}
		let re = /^(-?\d+)(\d{3})(\.?\d*)/;

		while (re.test(money)) {
			money = money.replace(re, "$1,$2$3");
		}

		return money;
	},

	/**
	 * 描述：还原金额格式，如：6,123,432.24 -> 6123432.24
	 *
	 * @param money: 待还原的金额字符串
	 */
	restoreMoney = (money) => {
		if (money) {
			return parseFloat(money.replace(/[^\d.-]/g, ""));
		}
		return money;
	},


	/**
	 * 描述：重写 javascript parseInt 方法
	 *
	 * @param str: 待转换的字符串，
	 * @param dftVal: 如果str为空或者parseInt解析结果为NaN时 返回的默认值 ，不传默认返回0
	 * @returns
	 */
	cusParseInt = (str, dftVal) => {
		dftVal = dftVal || 0;
		let result = dftVal;
		if (str) {
			result = parseInt(str) || dftVal; // 使用十进制进行转换
		}
		return result;
	},

	/**
	 * 描述：重写 javascript parseFloat 方法
	 *
	 * @param str: 待转换的字符串，
	 * @param dftVal: 如果str为空或者parseFloat解析结果为NaN时 返回的默认值 ，不传默认返回0
	 * @returns
	 */
	cusParseFloat = (str, dftVal) => {
		dftVal = dftVal || 0;
		let result = dftVal;
		if (str) {
			result = parseFloat(str) || dftVal; // 使用十进制进行转换
		}
		return result;
	},

	/**
	 * 描述： 数字大于一万时，以万为单位显示 如： 12345623 -> 1,234.56万
	 * @param num: 数字字符串
	 * @param dft: 字符串为空时默认显示值
	 * @param isMillions: 是否展示成亿元(0：不展示；1：展示)
	 */
	dealBigNumber = (num, dft, isMillions) => {
		if (num) {
			num = cusParseFloat(num);
			if (isMillions == "1") {
				num = (num / 100000000);
				num = cusParseFloat(num).toLocaleString();
				num = num;
			} else if (num >= 1000 && num < 10000) {
				num = cusParseFloat(num).toLocaleString();
			} else if (num >= 10000) {
				num = (num / 10000);
				num = cusParseFloat(num).toLocaleString();
				num = num + "万";
			} else {
				num = num.toLocaleString();
			}
		} else {
			num = dft || "--";
		}
		return num;
	},

	/**
	 * 描述：去掉字符串所有空格
	 * @param str: 字符串
	 */
	trimAll = (str) => {
		if (str) {
			return str.replaceAll(" ", "");
		}
		return str;
	},

	/**
	 * 数字转中文
	 */
	chinaNum = (num) => {
		num = num + "";
		let china = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
		let arr = [];
		let english = num.split("");
		for (let i = 0; i < english.length; i++) {
			arr[i] = china[english[i]];
		}
		return arr.join("");
	},

	/**
	 *    保留几位小数，不足补0
	 */
	formatNumber = (value, num) => {
		let a, b, c, i;
		a = value.toString();
		b = a.indexOf(".");
		c = a.length;
		if (num === 0) {
			if (b !== -1) {
				a = a.substring(0, b);
			}
		} else { // 如果没有小数点
			if (b === -1) {
				a = a + ".";
				for (i = 1; i <= num; i++) {
					a = a + "0";
				}
			} else { // 有小数点，超出位数自动截取，否则补0
				a = a.substring(0, b + num + 1);
				for (i = c; i <= b + num; i++) {
					a = a + "0";
				}
			}
		}
		return a;
	},

	/*
	 * 对变量进行空值处理，boolean、function、error、regexp除外
	 * @param value 变量
	 * @param defaultValue 默认值
	 * */
	formatEmpty = (value, defaultValue) => {
		// 1、获得格式化的数据类型，boolean除外
		let valueType = null;
		switch (typeof (value)) {
			case "undefined":
			case "null":
			case "string":
				valueType = "string";
				break;
			case "number":
				valueType = "number";
				break;
			case "array":
				valueType = "array";
				break;
			case "date":
				valueType = "date";
				break;
			case "object":
				valueType = "object";
				break;
			default:
				valueType = "string";
				break;
		}
		// 2、根据数据类型校验，返回对应的空值数据
		if (!value && valueType === "string") {
			value = defaultValue || "";
		} else if (!value && valueType === "number") {
			value = defaultValue || 0;
		} else if (valueType === "array" && value.length === 0) {
			value = defaultValue || [];
		} else if (valueType === "date" && value == "Invalid Date") {
			value = defaultValue || new Date();
		} else if (valueType === "object" && value === {}) {
			value = defaultValue || {};
		}

		return value;
	},

	//通过url字符串获取json参数
	parseQueryString = (url) => {
		let reg_url = /^[^\?]+\?([\w\W]+)$/,
			reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
			arr_url = reg_url.exec(url),
			ret = {};
		if (arr_url && arr_url[1]) {
			let str_para = arr_url[1],
				result;
			while ((result = reg_para.exec(str_para)) != null) {
				ret[result[1]] = result[2];
			}
		}
		return ret;
	},

	/**
	 ** 除法函数，用来得到精确的除法结果
	 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
	 ** 调用：accDiv(arg1,arg2)
	 ** 返回值：arg1除以arg2的精确结果
	 **/
	accDiv = (arg1, arg2) => {
		if (isNaN(arg1)) {
			arg1 = 0;
		}
		if (isNaN(arg2)) {
			arg2 = 0;
		}
		arg1 = Number(arg1);
		arg2 = Number(arg2);

		let t1 = 0,
			t2 = 0,
			r1, r2;
		try {
			t1 = arg1.toString().split(".")[1].length;
		} catch (e) {}
		try {
			t2 = arg2.toString().split(".")[1].length;
		} catch (e) {}
		/*JS严格模式下不支持with语句*/
		/*with (Math) {
		 r1 = Number(arg1.toString().replace(".", ""));
		 r2 = Number(arg2.toString().replace(".", ""));
		 return (r1 / r2) * pow(10, t2 - t1);
		 }*/
		r1 = Number(arg1.toString().replace(".", ""));
		r2 = Number(arg2.toString().replace(".", ""));
		return (r1 / r2) * Math.pow(10, t2 - t1);
	},

	/**
	 ** 乘法函数，用来得到精确的乘法结果
	 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
	 ** 调用：accMul(arg1,arg2)
	 ** 返回值：arg1乘以 arg2的精确结果
	 **/
	accMul = (arg1, arg2) => {
		if (isNaN(arg1)) {
			arg1 = 0;
		}
		if (isNaN(arg2)) {
			arg2 = 0;
		}
		arg1 = Number(arg1);
		arg2 = Number(arg2);

		let m = 0,
			s1 = arg1.toString(),
			s2 = arg2.toString();
		try {
			m += s1.split(".")[1].length;
		} catch (e) {}
		try {
			m += s2.split(".")[1].length;
		} catch (e) {}
		return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
	},

	/**
	 * 描述：重写 javascript parseFloat 方法
	 *
	 * @param str: 待转换的字符串，
	 * @param dftVal: 如果str为空或者parseFloat解析结果为NaN时 返回的默认值 ，不传默认返回0
	 * @param num: 保留几位小数 不传默认保留2位
	 * @param actNum: 结果需要乘以的数字
	 * @param addEnd
	 * @returns
	 */
	parseFloatFormat = (str, dftVal, num, actNum, addEnd) => {
		dftVal = dftVal || 0;
		num = num || 2;
		let result = dftVal;
		if (str || str == "0") {
			result = parseFloat(str); // 使用十进制进行转换
			if (!isNaN(result)) {

				if (!isNaN(actNum)) {
					result = Math.round(result * actNum * Math.pow(10, num)) / Math.pow(10, num);
				} else {
					result = Math.round(result * Math.pow(10, num)) / Math.pow(10, num);
				}

				result += addEnd;
			} else {
				result = dftVal;
			}
		}
		return result;
	},

	/** 将text中的html字符转义， 仅转义  ', ", <, > 四个字符
	 * @param  { String } str 需要转义的字符串
	 * @returns { String }     转义后的字符串
	 */
	unspchtml = (str) => {
		return str ? str.replace(/[<">']/g, function (a) {
			return {
				'<': '&lt;',
				'"': '&quot;',
				'>': '&gt;',
				"'": '&#39;'
			}
			[a];
		}) : '';
	},

	//根据是否等于某个值来得到单位
	unitHtml = (val, dftVal, unit) => {
		let str = "";
		if (val != dftVal) {
			str = unit;
		}
		return str;
	},

	//截取字符串返回数值型
	indexOfNumberValue = (strNumber, unit) => {
		strNumber = strNumber || 0;
		unit = unit || "%";
		if (strNumber) {
			if (strNumber.indexOf(unit)) {
				let index = strNumber.lastIndexOf(unit);
				strNumber = strNumber.substring(0, index);
				strNumber = parseFloat(strNumber);
				if (isNaN(strNumber)) {
					strNumber = 0;
				}
			}
		}
		return strNumber;
	},

	/**
	 * 比较2个版本号的大小
	 * addby chenyue 20180709
	 */
	versionfunegt = (curV, reqV) => {
		let arr1 = curV.split('.');
		let arr2 = reqV.split('.');
		//将两个版本号拆成数字
		let minL = Math.min(arr1.length, arr2.length);
		let pos = 0; //当前比较位
		let diff = 0; //当前为位比较是否相等
		//逐个比较如果当前位相等则继续比较下一位
		while (pos < minL) {
			diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
			if (diff != 0) {
				break;
			}
			pos++;
		}
		if (diff > 0) {
			return true;
		} else {
			return false;
		}
	};

/**************************************************************
 时间过期器
 ******************************************************************/
const
	/**
	 * 求两个时间的天数差 日期格式为 YYYY-MM-dd
	 * @param DateOne 较大的日期
	 * @param DateTwo 较小的日期
	 * @return {number}  差值
	 */
	daysBetween = (DateOne, DateTwo) => {
		let OneMonth = DateOne.substring(5, DateOne.lastIndexOf('-'));
		let OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf('-') + 1);
		let OneYear = DateOne.substring(0, DateOne.indexOf('-'));

		let TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf('-'));
		let TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf('-') + 1);
		let TwoYear = DateTwo.substring(0, DateTwo.indexOf('-'));

		let cha = ((Date.parse(OneMonth + '/' + OneDay + '/' + OneYear) - Date.parse(TwoMonth + '/' + TwoDay + '/' + TwoYear)) / 86400000);
		return Math.abs(cha);
	},

	/**
	 * 字符串和时间戳转换为Date类型
	 * @param DateStr
	 * @return {Date}
	 * @constructor
	 */
	stringToDate = (DateStr) => {
		return DateStr ? new Date(DateStr) : new Date()
	},

	/**
	 * 日期合法性验证
	 * 格式为：YYYY-MM-DD或YYYY/MM/DD
	 * @param DateStr
	 * @return {boolean}
	 * @constructor
	 */
	isValidDate = (DateStr) => {
		let sDate = DateStr.replace(/(^\s+|\s+$)/g, ''); //去两边空格;
		if (sDate === '') return false;
		//如果格式满足YYYY-(/)MM-(/)DD或YYYY-(/)M-(/)DD或YYYY-(/)M-(/)D或YYYY-(/)MM-(/)D就替换为''
		//数据库中，合法日期可以是:YYYY-MM/DD(2003-3/21),数据库会自动转换为YYYY-MM-DD格式
		let s = sDate.replace(/[\d]{ 4,4 }[\-/]{ 1 }[\d]{ 1,2 }[\-/]{ 1 }[\d]{ 1,2 }/g, '');
		if (s !== '') //说明格式满足YYYY-MM-DD或YYYY-M-DD或YYYY-M-D或YYYY-MM-D
		{
			let t = new Date(sDate.replace(/-/g, '/'));
			let ar = sDate.split(/[-/: ]/);
			if (ar[0] != t.getFullYear() || ar[1] != t.getMonth() + 1 || ar[2] != t.getDate()) {
				//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。');
				return false;
			} else {
				return true;
			}
		} else {
			//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。');
			return false;
		}
	},

	/**
	 * 日期时间检查
	 * 格式为：YYYY-MM-DD HH:MM:SS
	 * @param str
	 * @return {boolean}
	 * @constructor
	 */
	checkDateTime = (str) => {
		let reg = /^(\d+)-(\d{ 1,2 })-(\d{ 1,2 }) (\d{ 1,2 }):(\d{ 1,2 }):(\d{ 1,2 })$/;
		let r = str.match(reg);
		if (r === null) return false;
		r[2] = r[2] - 1;
		let d = new Date(r[1], r[2], r[3], r[4], r[5], r[6]);
		if (d.getFullYear() != r[1]) return false;
		if (d.getMonth() != r[2]) return false;
		if (d.getDate() != r[3]) return false;
		if (d.getHours() != r[4]) return false;
		if (d.getMinutes() != r[5]) return false;
		if (d.getSeconds() != r[6]) return false;
		return true;
	},

	/**
	 * 描述： 把日期格式字符串转换成js Date类型
	 *
	 * @author 汪卫中
	 * @param dateStr: 日期字符串 格式必须为 yyyy-MM-dd hh:mm:ss 或 yyyy-MM-dd hh:mm:ss.S
	 * @returns 返回JS日期对象
	 */
	getDateByStr = (dateStr) => {
		if (!dateStr) {
			return;
		}
		//去掉后面毫秒数
		if (dateStr.indexOf(".") != -1) {
			dateStr = dateStr.substring(0, dateStr.indexOf("."));
		}

		// 形如20160101120101转换成2016-01-01 12:01:01
		if ((dateStr.replace(/^\s+|\s+$/gm, '')).length == 14 && dateStr.indexOf("-") == -1) {
			dateStr = dateStr.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6');
		}

		// 形如20160101转换成2016-01-01
		if ((dateStr.replace(/^\s+|\s+$/gm, '')).length == 8 && dateStr.indexOf("-") == -1) {
			dateStr = dateStr.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3 00:00:00');
		}
		dateStr = dateStr.replace(new RegExp("-", "gm"), "/");
		return new Date(dateStr);
	},

	/**
	 * 描述：把yyyy-MM-dd hh:mm:ss (.S)日期字符串转化为指定格式的日期字符串
	 *
	 * @author 汪卫中
	 * @param srcDate: 1、源日期为日期格式的字符串 如：2015-11-12 11:34:45
	 *                   2、源日期为Date类型 如：new Date();
	 * @param fmt: 格式，如：yyyy-MM-dd
	 */
	dateFormat = (srcDate, fmt) => {
		if (!srcDate || !fmt) {
			return srcDate;
		}
		if (srcDate.length === 8) { //支持yyyyMMdd格式的
			srcDate = srcDate.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
		}
		// 把字符串转换成日期对象
		let date = (typeof (srcDate) == "object") ? srcDate : getDateByStr(srcDate);

		// 非date类型时返回原字符串
		if (isNaN(date.getDay())) {
			return srcDate;
		}

		let o = {
			"M+": date.getMonth() + 1, // 月份
			"d+": date.getDate(), // 日
			"h+": date.getHours(), // 小时
			"m+": date.getMinutes(), // 分
			"s+": date.getSeconds(), // 秒
			"q+": Math.floor((date.getMonth() + 3) / 3), // 季度
			"S": date.getMilliseconds() // 毫秒
		};

		// 年份比较特殊，单独处理
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (let k in o) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	},

	//获取一个月最后一天
	getLastDay = (year, month) => {
		let new_year = year; //取当前的年份
		let new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
		if (month > 12) //如果当前大于12月，则年份转到下一年
		{
			new_month -= 12; //月份减
			new_year++; //年份增
		}
		let new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
		return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月最后一天日期
	},

	/**
	 * 获取从开始日期到结束日期的月份集合
	 * start_date 开始日期
	 * end_date  结束日期
	 * fmt 格式化 yyyy-MM  yyyy年MM月
	 */
	getMonthList = (start_date, end_date, fmt) => {
		let resultMonth = [];
		fmt = fmt || "yyyy-MM";
		if (start_date && end_date) {
			// 把字符串转换成日期对象
			let startDate = (typeof (start_date) == "object") ? start_date : getDateByStr(start_date);
			// 非date类型时返回原字符串
			if (isNaN(startDate.getDay())) {
				return resultMonth;
			}
			// 把字符串转换成日期对象
			let endDate = (typeof (end_date) == "object") ? end_date : getDateByStr(end_date);
			// 非date类型时返回原字符串
			if (isNaN(endDate.getDay())) {
				return resultMonth;
			}
			if (startDate.DateDiff("m", endDate) < 0) { //结束日期月份小于开始日期月份
				return resultMonth;
			}

			let startYear = startDate.getFullYear(); //开始日期年份
			let startMonth = startDate.getMonth() + 1; //开始日期月份
			if (startMonth == 1) {
				startYear--;
				startMonth = 12;
			}
			let endYear = endDate.getFullYear(); //结束日期年份
			let endMonth = endDate.getMonth() + 1; //结束日期月份
			if (endMonth == 1) {
				endYear--;
				endMonth = 12;
			}
			for (let i = startYear; i <= endYear; i++) {
				for (let j = 1; j <= 12; j++) {
					if (!((i == startYear && j < startMonth) || (i == endYear && j > endMonth))) {
						let monthStr = "";
						if (j < 10) {
							monthStr = "0" + j;
						} else {
							monthStr = j;
						}
						let yearMonth = i + "-" + monthStr + "-01"; //IOS中 new Date(yyyy/MM)不能格式化，需拼接完整日期
						yearMonth = dateFormat(yearMonth, fmt);
						resultMonth.push(yearMonth);
					}
				}
			}
		}
		return resultMonth;
	},
	//时间格式化
	timeFormat = (time) => {
		let timeStr = '';
		if (time && time >= 6) {
			timeStr = time.substring(0, 2) + ':' + time.substring(2, 4) + ":" + time.substring(4, 6);
		} else {
			timeStr = time;
		}
		return timeStr;
	};

export default {
	moneyFormat,
	restoreMoney,
	cusParseInt,
	cusParseFloat,
	parseFloatFormat,
	trimAll,
	dealBigNumber,
	chinaNum,
	formatNumber,
	parseQueryString,
	formatEmpty,
	accDiv,
	accMul,
	unspchtml,
	unitHtml,
	indexOfNumberValue,
	stringToDate,
	isValidDate,
	checkDateTime,
	daysBetween,
	getDateByStr,
	dateFormat,
	getLastDay,
	getMonthList,
	timeFormat
}



// WEBPACK FOOTER //
// ./src/filters/filters.js